/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SessionRunParticipantStateType {
    /**
     * Participant needs to login
     */ 
    PendingLogin = 1,
    /**
     * Participant needs to confirm readiness (e.g. examiner/standardized patient who doesn't need to login every student ready phase, but need to confirm readiness for the next run)
     */ 
    PendingConfirmation = 2,
    /**
     * Participant is ready to proceed
     */ 
    Ready = 3,
    /**
     * Participant is absent from the exam
     */ 
    Aborted = 4,
}
